<template>
  <div class="upload-prospectus-container">
    <input 
      type="file" 
      accept=".pdf"
      ref="file"
      style="display: none"
      @change="uploadPdf" />

    <v-btn
      color="primary darken-1"
      outlined
      hide-details
      :title="buttonTitle"
      :disabled="uploading"
      :loading="uploading"
      class="mr-3 elevation-1"
      @click="$refs.file.click()"
    >
      upload <v-icon class="ml-2 primary--text text--darken-2">mdi-cloud-upload</v-icon>
    </v-btn>

    <!-- <v-btn
      v-if="(lastUploadedPdf && lastUploadedPdf !== 'Never') || currentUploadTime"
      hide-details
      class="mr-4"
      @click="downloadPdf"
    >
      download <v-icon class="ml-2 primary--text text--darken-3">mdi-cloud-download</v-icon>
    </v-btn> -->
    
  </div>
</template>

<script>
import axios from 'axios'
import Cookie from 'js-cookie'
import dateformat from 'dateformat'

import appUrls from '../../helpers/environment'

export default {
  name: 'UploadProspectusPdf',

  props: {
    listingId: String,
    lastUploadedPdf: String,
  },

  data: () => ({
    uploading: false,
    currentUploadTime: '',
  }),

  computed: {
    buttonTitle () {
      const time = this.currentUploadTime || this.lastUploadedPdf
      return `Last Uploaded: ${time ? dateformat(time) : 'Never'}`
    },
  },

  methods: {
    async uploadPdf (event) {
      this.uploading = true

      try {
        const formData = new FormData()
        formData.append('file', event.target.files[0])

        const data = await axios.post(
          `${appUrls.api}/api/admin/upload-prospectus-pdf/${this.listingId}`,
          formData,
          {
            headers: {
              authentication: Cookie.get('token'),
              'Content-Type': 'multipart/form-data',
            },
          },
        )

        this.currentUploadTime = dateformat(new Date())

        this.$feedback.success( 'Uploaded the PDF and saved it to S3' )
      } catch (err) {
        this.$feedback.error( `There was a problem uploading the PDF. ${err.message}` )

        console.error('Failed to upload PDF', err)
      }

      event.target.value = ''
      this.uploading = false
    },

    downloadPdf () {
        window.open(`${appUrls.api}/api/listing-details-pdf/${this.listingId}`)
    }
  },
}
</script>

<style scoped>
  .upload-prospectus-container {
    display: flex;
    justify-content: flex-end;
  }
</style>



// WEBPACK FOOTER //
// src/components/partials/uploadProspectusPdf.vue